import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { getNavigationSidebarProductsSettingResource } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyComponentEntryPointContainer } from '@jira/router-routes__common/src/LegacyComponentEntryPointContainer.tsx';
import { globalSettingsProductsApplinksRoute } from '@jira/router-routes__legacy-global-settings-products-applinks-routes/src/globalSettingsProductsApplinksRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import ModernApplinksCreateDrawer from './ModernApplinksCreateDrawer.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

const EMPTY_PROPS = {};
const modernApplinksCreateDrawerEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-modern-applinks-create-drawer" */ './ModernApplinksCreateDrawerWithRouteInfo.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => EMPTY_PROPS,
	},
});

export const globalSettingsProductsApplinksRouteEntry: LegacyEntryRoute<RouteResources> =
	createLegacyEntry(globalSettingsProductsApplinksRoute, () => ({
		layout: globalSettingsLayout,
		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_project_workflow')
			? undefined
			: ModernApplinksCreateDrawer,
		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: getNavigationSidebarProductsSettingResource(),
		entryPoint: () =>
			fg('nike_entrypoint_migration_project_workflow')
				? modernApplinksCreateDrawerEntryPoint
				: pageEntryPoint,
		entryPointContainer: fg('nike_entrypoint_migration_project_workflow')
			? LegacyComponentEntryPointContainer
			: undefined,
	}));
